import { useState, useEffect, useRef, useNavigate } from 'react';
import { Modal } from 'react-bootstrap';
import ModalContent from '../../../routes/SmartInspect/Warren/assets/ModalContent';

import PropTypes from 'prop-types';
import Fuse from 'fuse.js';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';

import data from './SearchData';

// function for our SearchBlur component (to hide results if you click away)
function useSearchBlur(ref) {
	useEffect(() => {
		function handleOutsideClick(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				document.getElementById('results').style.display = 'none';
			}
		}

		document.addEventListener('mousedown', handleOutsideClick);
		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [ref]);
}
// SearchBlur component
const SearchBlur = (props) => {
	const wrapperRef = useRef(null);
	useSearchBlur(wrapperRef);

	return <div ref={wrapperRef}>{props.children}</div>;
};

// prop specifications for SearchBlur
SearchBlur.propTypes = {
	children: PropTypes.element.isRequired,
};

const options = {
	keys: [
		{ name: 'tab', weight: 2 },
		{ name: 'page', weight: 1 },
		{ name: 'keywords', weight: 1 },
	],
	minMatchCharLength: 2,
	threshold: 0.3,
};

const Search = ({ className, homeSearch }) => {
	const [searchTerm, setSearchTerm] = useState('');
	const [results, setResults] = useState([]);

	// modal state and handlers
	const [modal, setModal] = useState({
		title: '',
		content: '',
	});
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, content) => {
		setModal({ title: title, content: content });
		setShowModal(true);
	};
	// onClick={() => handleShowModal('Introduction to SMARTInspect', 'intro')}

	const handleSearch = (e) => {
		const { value } = e.target;
		setSearchTerm(value);

		const fuse = new Fuse(data, options);
		const result = fuse.search(value);
		setResults(result);
		document.getElementById('results').style.display = 'block';
	};

	return (
		<>
			<SearchBlur>
				<div className={className}>
					<div className="search-bar">
						<FaSearch size={20} />
						<input type="text" value={searchTerm} onChange={handleSearch} />
					</div>

					{results.length > 0 && (
						<ul id="results">
							{results.map(({ item }) => {
								return (
									<li>
										{item.section === 'Operation' ? (
											<a onClick={() => handleShowModal(item.tab, item.modal)} style={{ color: `${item.color}`, cursor: 'pointer' }}>
												{item.tab} <i style={{ fontSize: '17px' }}>({item.section})</i>
											</a>
										) : (
											<a href={item.link} style={{ color: `${item.color}` }}>
												{item.tab}{' '}
												<i style={{ fontSize: '17px' }}>
													({item.section} &gt; {item.page})
												</i>
											</a>
										)}
									</li>
								);
							})}
						</ul>
					)}
				</div>
			</SearchBlur>

			<Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="course-modal" centered>
				<Modal.Header closeButton>
					<Modal.Title>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ModalContent content={modal.content} />
				</Modal.Body>
			</Modal>
		</>
	);
};

const SearchBar = styled(Search)`
	background: black;
	position: absolute;
	top: ${(props) => props.display};
	z-index: 20;
	width: 100%;
	height: 8vh;
	transition: top 0.3s ease-in-out;

	.search-bar {
		display: flex;
		justify-content: center;
		height: 100%;
		width: 60%;
		margin: 0 auto;
	}

	& svg {
		display: block;
		margin: auto 5px;
		color: white;
	}
	& input {
		height: 5vh;
		width: 90%;
		margin: auto 10px;
		border-radius: 1em;
	}

	& ul {
		padding: 0;
		background: #e5e5e5;
		width: 50%;
		margin: auto;
		list-style: none;
		font-size: 22px;
		font-weight: bold;
		border: solid black;
		border-radius: 1rem;

		& li {
			border-top: solid black 1px;
			border-bottom: solid black 1px;
			padding: 10px;
			& a {
				text-decoration: none;
				text-shadow: 0.5px 0.3px 1px black;
			}
		}
	}

	@media screen and (max-width: 480px) {
		& ul {
			width: 95%;
			& li {
				font-size: 16px;

				& i {
					font-size: 14px !important;
				}
			}
		}
	}
`;

export default SearchBar;
